export enum LoiComparisonSubTab {
    LoiForm = 1,
    LegalIssues = 2,
    AdditionalNdaCovenants = 3,
}

export const LoiComparisonSubTabs = [
    {
        id: LoiComparisonSubTab.LoiForm,
        content: 'LOI Summary',
    },
    {
        id: LoiComparisonSubTab.LegalIssues,
        content: 'Legal Issues',
    },
    {
        id: LoiComparisonSubTab.AdditionalNdaCovenants,
        content: 'Additional NDA Covenants',
    },
];
